import React from 'react'
import { Link } from "react-router-dom";


const ProductDetails = () => {
    return (
        <>
            <div className="page-header">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-12">
                            <div className="page-header-box">
                                <h1 className="text-anime-style-3" data-cursor="-opaque" style={{ perspective: 400 }}>
                                    <div className="split-line" style={{ display: 'block', textAlign: 'center', position: 'relative' }}>
                                        Product View
                                    </div>
                                </h1>
                                <nav className="wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/">home</Link></li>
                                        <li className="breadcrumb-item active" aria-current="page">Product View</li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="page-single-post">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            {/* Post Featured Image Start */}
                            <div className="post-image">
                                <figure className="image-anime reveal" style={{ transform: 'translate(0px, 0px)', opacity: 1, visibility: 'inherit' }}>
                                    <img src="assets/img/product-details.jpg" alt style={{ transform: 'translate(0px, 0px)' }} />
                                </figure>
                            </div>
                            {/* Post Featured Image Start */}
                            {/* Post Single Content Start */}
                            <div className="post-content">
                                {/* Post Entry Start */}
                                <div className="post-entry">
                                    <p className="wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>CND Mahua Shakti Blend is a premium natural superfood blend crafted from Mahua and 11+ carefully selected ingredients, including dry fruits, seeds, roasted grains elements. Inspired by the nutritional wisdom of India, this wholesome blend is designed to provide strength, stamina, energy, and overall wellness in every serving.</p>
                                    <p className="wow fadeInUp" data-wow-delay="0.2s" style={{ visibility: 'visible', animationDelay: '0.2s', animationName: 'fadeInUp' }}>Each ingredient is hygienically roasted and blended to preserve its natural goodness, rich flavor, and nutritional value. The combination of Mahua, Kaju, Badam, Chhuara, Makhana, Bhuna Chana, Flaxseed, Sesame, Garden Cress, Dry Ginger, Cardamom, and other natural ingredients creates a balanced source of plant-based nutrition that supports an active and healthy lifestyle.</p>
                                    <p className="wow fadeInUp" data-wow-delay="0.2s" style={{ visibility: 'visible', animationDelay: '0.2s', animationName: 'fadeInUp' }}>Whether mixed with warm milk, smoothies, porridge, or enjoyed as part of your daily diet, CND Mahua Shakti Blend offers a delicious and convenient way to nourish your body naturally.</p>
                                    <blockquote className="wow fadeInUp" data-wow-delay="0.4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                                        <p>CND Mahua Shakti Blend – The Power of Nature, Perfected.</p>
                                    </blockquote>
                                    <h2 className="wow fadeInUp" data-wow-delay="0.8s" style={{ visibility: 'visible', animationDelay: '0.8s', animationName: 'fadeInUp' }}>Key Benefits</h2>
                                    <ul className="wow fadeInUp" data-wow-delay="1.2s" style={{ visibility: 'visible', animationDelay: '1.2s', animationName: 'fadeInUp' }}>
                                        <li>100% Natural Ingredients</li>
                                        <li>No Added Chemicals</li>
                                        <li> Rich in Nutrients & Plant Protein</li>
                                        <li> Supports Strength, Stamina & Vitality</li>
                                        <li> Traditional Nutrition for Modern Wellness </li>
                                        <li> Perfect for Daily Energy and Overall Well-Being</li>
                                    </ul>
                                    <p className="wow fadeInUp" data-wow-delay="1.4s" style={{ visibility: 'visible', animationDelay: '1.4s', animationName: 'fadeInUp', textAlign:"justify" }}>CND Mahua Shakti Blend is a premium superfood blend based on Mahua. It combines the goodness of natural ingredients, dry fruits, and seeds, helping you stay strong, energetic, and healthy every day.</p>
                                </div>
                                {/* Post Entry End */}
                                {/* Post Tag Links Start */}
                                <div className="post-tag-links">
                                    <div className="row align-items-center">
                                        <div className="col-lg-8">
                                            {/* Post Tags Start */}
                                            <div className="post-tags wow fadeInUp" data-wow-delay="0.5s" style={{ visibility: 'visible', animationDelay: '0.5s', animationName: 'fadeInUp' }}>
                                                <span className="tag-links">
                                                    <Link to="https://wa.me/+916262556132" target="_blank">Buy Now</Link>
                                                    <Link to="/about-us">About us</Link>
                                                    <Link to="https://www.indiapost.gov.in/" target="_blank">Track Order</Link>
                                                </span>
                                            </div>
                                            {/* Post Tags End */}
                                        </div>
                                        <div className="col-lg-4">
                                            {/* Post Social Links Start */}
                                            <div className="post-social-sharing wow fadeInUp" data-wow-delay="0.5s" style={{ visibility: 'visible', animationDelay: '0.5s', animationName: 'fadeInUp' }}>
                                                <ul>
                                                    <li><Link to="https://www.instagram.com/mahuasaktiblend/" target="_blank"><i className="fa-brands fa-instagram" /></Link></li>
                                                    <li><Link to="https://www.facebook.com/profile.php?id=61592758712504" target="_blank"><i className="fa-brands fa-facebook-f" /></Link></li>
                                                    {/* <li><Link to="/"><i className="fa-brands fa-youtube" /></Link></li>
                                                    <li><Link to="/"><i className="fa-brands fa-x-twitter" /></Link></li> */}
                                                </ul>
                                            </div>
                                            {/* Post Social Links End */}
                                        </div>
                                    </div>
                                </div>
                                {/* Post Tag Links End */}
                            </div>
                            {/* Post Single Content End */}
                        </div>
                    </div>
                </div>
            </div>


            {/* <div className="page-features" style={{marginTop:"-80px"}}>
                <div className="container">
                    <div className="row features-item-list">
                        <div className="col-lg-4 col-md-6">
                            <div className="features-item wow fadeInUp active" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                                <div className="icon-box">
                                    <img src="assets/images/icon-features-1.svg" alt />
                                </div>
                                <div className="features-item-content">
                                    <h3>Natural Ingredients</h3>
                                    <p>We believe in keeping things real. Thats why all our products are made using natural, clean and easily recognizable ingredients.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="features-item wow fadeInUp" data-wow-delay="0.2s" style={{ visibility: 'visible', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                                <div className="icon-box">
                                    <img src="assets/images/icon-features-2.svg" alt />
                                </div>
                                <div className="features-item-content">
                                    <h3>Sourced Ingredients</h3>
                                    <p>We believe in keeping things real. Thats why all our products are made using natural, clean and easily recognizable ingredients.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="features-item wow fadeInUp" data-wow-delay="0.4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                                <div className="icon-box">
                                    <img src="assets/images/icon-features-3.svg" alt />
                                </div>
                                <div className="features-item-content">
                                    <h3>Flavor Experience</h3>
                                    <p>We believe in keeping things real. Thats why all our products are made using natural, clean and easily recognizable ingredients.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="features-item wow fadeInUp" data-wow-delay="0.6s" style={{ visibility: 'visible', animationDelay: '0.6s', animationName: 'fadeInUp' }}>
                                <div className="icon-box">
                                    <img src="assets/images/icon-features-4.svg" alt />
                                </div>
                                <div className="features-item-content">
                                    <h3>Honest Care</h3>
                                    <p>We believe in keeping things real. Thats why all our products are made using natural, clean and easily recognizable ingredients.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="features-item wow fadeInUp" data-wow-delay="0.8s" style={{ visibility: 'visible', animationDelay: '0.8s', animationName: 'fadeInUp' }}>
                                <div className="icon-box">
                                    <img src="assets/images/icon-features-5.svg" alt />
                                </div>
                                <div className="features-item-content">
                                    <h3>Quality Tested</h3>
                                    <p>We believe in keeping things real. Thats why all our products are made using natural, clean and easily recognizable ingredients.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="features-item wow fadeInUp" data-wow-delay="1s" style={{ visibility: 'visible', animationDelay: '1s', animationName: 'fadeInUp' }}>
                                <div className="icon-box">
                                    <img src="assets/images/icon-features-6.svg" alt />
                                </div>
                                <div className="features-item-content">
                                    <h3>Traditional Pickles</h3>
                                    <p>We believe in keeping things real. Thats why all our products are made using natural, clean and easily recognizable ingredients.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}


        </>
    )
}

export default ProductDetails